import { Box, Grid2 as Grid } from '@mui/material';
import { Image } from '@shopify/hydrogen';
import type { FC } from 'react';

import type { BrandCarouselProps } from '~/types/sanity/components';
import { getCompoundTestIdGenerator } from '~/utils/getCompoundTestIdGenerator';

type BrandCarouselSlideProps = NonNullable<BrandCarouselProps['slides']>[0];

export const BrandCarouselSlide: FC<BrandCarouselSlideProps> = ({ images }) => {
  const getCompoundTestId = getCompoundTestIdGenerator('brandCarouselSlide');

  return (
    <Box p={2} pb={4} data-testid={getCompoundTestId()}>
      <Grid container rowSpacing={3} columnSpacing={1}>
        {images.map(({ _key, alt, image }) => {
          const { url, metadata } = image ?? {};
          const { width, height } = metadata?.dimensions ?? {};
          return (
            <Grid size={{ xs: 4, md: 2 }} key={_key}>
              <Box height={60}>
                {url && (
                  <Image
                    src={url}
                    alt={alt ?? ''}
                    {...(width && { width })}
                    {...(height && { height })}
                    style={{
                      maxWidth: 120,
                      width: '100%',
                      height: '100%',
                      objectFit: 'contain',
                    }}
                  />
                )}
              </Box>
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
};
